/**
 * Impl do use case de provisionamento de IES (organization).
 *
 * @since G.5.25
 */
import type { OnboardTenantCommand, OnboardTenantResult } from '@/domain/model/TenantOnboarding';
import type { TenantOnboardingGateway } from '@/application/port/out/TenantOnboardingGateway';
import type { OnboardTenantUseCase } from '@/application/port/in/TenantOnboardingUseCase';

export class OnboardTenant implements OnboardTenantUseCase {
  constructor(private readonly gateway: TenantOnboardingGateway) {}
  execute(cmd: OnboardTenantCommand): Promise<OnboardTenantResult> {
    return this.gateway.onboard(cmd);
  }
}
